var config = {
  wrapper: ".js-archiveListingContainer",
  container: ".js-archiveListingBody",
  filter: ".js-archiveFilter",
  filterItem: ".js-archiveFilter-item",
  loadMore: ".js-archiveListingLoadMore",
  gridItem: "js-grid-item",
  loaderDelay: 400,
  class: {
    hidden: "d-none",
    active: "is-active",
    loading: "is-loading"
  }
};
var archive = {
  init: function init() {
    var containers = $(config.wrapper);
    if (containers.length === 0) return;
    containers.each(function (pos, el) {
      var wrapper = $(el);
      var loadmoreBtn = wrapper.find(config.loadMore);
      var filter = wrapper.find(config.filter);
      var container = wrapper.find(config.container);
      var containerData = container.data("filters");
      var initShow = typeof containerData.perPage !== 'undefined' && containerData.perPage > 0 ? parseInt(containerData.perPage) : -1;
      var counter = initShow;

      // init Isotope
      var grid = container.isotope({
        itemconfig: config.gridItem,
        layoutMode: "fitRows",
        transitionDuration: '1s',
        getSortData: {
          category: "[data-category]"
        }
      });

      // Reset page on page load
      archive.loadMore(initShow, grid, loadmoreBtn);

      // Filter item click event
      if (filter.length) {
        filter.find(config.filterItem).on("click", function (e) {
          var $this = $(e.currentTarget);
          var filterValue = $this.attr("data-filter");
          wrapper.find("".concat(config.filter, " ").concat(config.filterItem)).removeClass(config.class.active);
          $this.addClass(config.class.active);
          grid.isotope({
            filter: filterValue
          });

          // Reset page
          counter = initShow;
          archive.loadMore(initShow, grid, loadmoreBtn);
        });
      }

      // Load more click event
      if (loadmoreBtn.length) {
        loadmoreBtn.on("click", function (e) {
          counter = counter + initShow;

          // Hide load more button and display spinner
          var btn = $(e.currentTarget);
          btn.addClass(config.class.loading);
          setTimeout(function () {
            // remove load more spinner
            btn.removeClass(config.class.loading);

            // Update listing layout
            archive.loadMore(counter, grid, btn);
          }, config.loaderDelay);
        });
      }
    });
  },
  loadMore: function loadMore(toShow, grid, loadmoreBtn) {
    grid.find(".".concat(config.class.hidden)).removeClass(config.class.hidden);
    var iso = grid.data("isotope");

    // show all if toshow is less than 1
    if (toShow < 1) {
      toShow = iso.filteredItems.length;
    }
    var hiddenElems = iso.filteredItems.slice(toShow, iso.filteredItems.length).map(function (item) {
      return item.element;
    });
    $(hiddenElems).addClass(config.class.hidden);
    grid.isotope("layout");

    //when no more to load, hide show more button
    if (hiddenElems.length == 0) {
      loadmoreBtn.addClass(config.class.hidden);
    } else {
      loadmoreBtn.removeClass(config.class.hidden);
    }
  },
  finalize: function finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  }
};
export default archive;


// WEBPACK FOOTER //
// ./scripts/routes/archive.js